import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  TipoControl,
  TablaMaestra,
  InformacionTablaMaestra,
  ValoresEspecificos,
  TramitSelectorFiel,
  DynamicSelector
} from '@app/shared';

@Injectable()
export class CreationFormDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService ) { }

  /**
   * retorna los tipos de controles(Campos) registrados en el sistema
   *
   * @returns {Observable<TipoControl[]>}
   * @memberof CreationFormDataService
   */
  getTypesControl(): Observable<TipoControl[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<TipoControl[]>(this.api.get('typeField')).subscribe(
        field => {
          const formattedData: TipoControl[] = [];
          field.forEach((el: TipoControl) => {
            formattedData.push({
              nombre: el.nombre,
              descripcion: el.descripcion,
              id: el.id
            });
          });
          obs.next(formattedData);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta la lista de tablas maestras del sistema
   *
   * @returns {Observable<TablaMaestra[]>}
   * @memberof CreationFormDataService
   */
  getMasterTables(): Observable<TablaMaestra[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<TablaMaestra[]>(this.api.get('masterTable')).subscribe(
        masterTables => {
          obs.next(masterTables);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          obs.error(err);
        }
      );
    });
  }


  getTramitFields(): Observable<TramitSelectorFiel[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<TramitSelectorFiel[]>(this.api.get('selectorUtil')).subscribe(
        tf => {
          obs.next(tf);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          obs.error(err);
        }
      );
    });
  }

  getDynamicSelectorFields(): Observable<DynamicSelector[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<DynamicSelector[]>(this.api.get('selectorDynamic')).subscribe(
        tf => {
          obs.next(tf);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta la informacion de las tablas maestras
   *
   * @param {number} idMaster
   * @returns {Promise<InformacionTablaMaestra>}
   * @memberof CreationFormDataService
   */
  getInformacionMasterTable(idMaster: number): Promise<InformacionTablaMaestra> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
       .get<InformacionTablaMaestra>(this.api.get('structureMasterTable', [ idMaster ])).subscribe(
        masterTable => {
          resolve(masterTable);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Realiza la consulta de las columnas specificas de una maestra
   *
   * @param {*} structure
   * @return {*}  {Promise<ValoresEspecificos[]>}
   * @memberof CreationFormDataService
   */
  getColumnsSpecificMasterTable(structure: any): Promise<ValoresEspecificos[]> {
    return new Promise((resolve, reject) => {
      this.http.post<ValoresEspecificos[]>(this.api.get('masterTableSpecificInformation'),
        { estructura: structure }).subscribe(
          specificValues => {
            resolve(specificValues);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   * Consulta la lista de consultas personalizadas
   *
   * @returns {Observable<any[]>}
   * @memberof CreationFormDataService
   */
   getCustomSerach(): Observable<any[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<any[]>(this.api.get('customSerachAdmin')).subscribe(
        cs => {
          obs.next(cs);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          obs.error(err);
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/shared/creation-form-data.service.ts